import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_SERVICES_PAGINATION_QUERY } from "@/graphql/queries/configuration/service/get-services-pagination.query";

const service = {
  actions: {
    async getServicesQuery({ commit }, { skip, take, orderBy, query }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_SERVICES_PAGINATION_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query,
          },
          fetchPolicy: "no-cache",
        });
      });
    },
  },
};

export default service;
